import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { translations } from '../translations';
export function TestimonialCarousel() {
  const {
    language
  } = useLanguage();
  const t = translations.home[language];
  const testimonials = t.testimonials;
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1);
  const next = useCallback(() => {
    setDirection(1);
    setCurrent(prev => (prev + 1) % testimonials.length);
  }, []);
  const prev = useCallback(() => {
    setDirection(-1);
    setCurrent(prev => (prev - 1 + testimonials.length) % testimonials.length);
  }, []);
  useEffect(() => {
    const timer = setInterval(next, 7000);
    return () => clearInterval(timer);
  }, [next]);
  const slideVariants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 80 : -80,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -80 : 80,
      opacity: 0
    })
  };
  return <section className="bg-[#7D6666] py-20 md:py-28 px-6" data-id="element-59" data-mp="2z4bcou4pvd9e">
      <div className="max-w-4xl mx-auto text-center" data-id="element-60" data-mp="2uagphgpwkg5k">
        <motion.h2 className="text-3xl md:text-4xl font-cinzel text-[#B89A6F] mb-16 tracking-wider" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} data-id="element-61" data-mp="2pcf3amx6k0pv">
          {t.testimonialsTitle}
        </motion.h2>

        <div className="relative flex items-center justify-center min-h-[280px] md:min-h-[240px]" data-id="element-62" data-mp="2beqitg70yvlc">
          {/* Previous Arrow */}
          <button onClick={prev} className="absolute left-0 md:-left-6 z-10 p-2 text-[#B89A6F] hover:text-[#d4b882] transition-colors" aria-label="Previous testimonial" data-id="element-63" data-mp="9l0zgnyicvgz">
            <ChevronLeftIcon className="w-7 h-7" strokeWidth={1.5} data-id="element-64" data-mp="4k3i2dlbo5gj" />
          </button>

          {/* Card */}
          <div className="w-full max-w-2xl mx-12 md:mx-16 overflow-hidden" data-id="element-65" data-mp="1z0ljqtgr8lmc">
            <AnimatePresence mode="wait" custom={direction} data-id="element-66" data-mp="23ufyrjlf0cf3">
              <motion.div key={current} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
              duration: 0.5,
              ease: 'easeInOut'
            }} className="bg-white/10 backdrop-blur-sm rounded-lg px-8 py-10 md:px-12 md:py-12" data-id="element-67" data-mp="1p5a0pyybcs8s">
                <p className="font-inter text-white/90 text-base md:text-lg leading-relaxed mb-8 italic" data-id="element-68" data-mp="2mqxwqiqux8js">
                  "{testimonials[current].quote}"
                </p>
                <p className="font-inter text-[#B89A6F] text-sm tracking-widest uppercase text-right" data-id="element-69" data-mp="2cta2dtx5y325">
                  — {testimonials[current].name}
                </p>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Next Arrow */}
          <button onClick={next} className="absolute right-0 md:-right-6 z-10 p-2 text-[#B89A6F] hover:text-[#d4b882] transition-colors" aria-label="Next testimonial" data-id="element-70" data-mp="11cbe84hrffqh">
            <ChevronRightIcon className="w-7 h-7" strokeWidth={1.5} data-id="element-71" data-mp="ovipt94qf08f" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-3 mt-8" data-id="element-72" data-mp="13r8drcth9nfs">
          {testimonials.map((_, idx) => <button key={idx} onClick={() => {
          setDirection(idx > current ? 1 : -1);
          setCurrent(idx);
        }} className={`w-2 h-2 rounded-full transition-all duration-300 ${idx === current ? 'bg-[#B89A6F] scale-125' : 'bg-white/30'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-73" data-mp="yuzrzgkryvzn" data-mpi={idx} />)}
        </div>
      </div>
    </section>;
}